export function ShareIcon({
  width,
  height,
  ...props
}: React.SVGProps<SVGSVGElement> & { fill?: string }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.0004 2L4.60938 5.5415"
        stroke="#3D352E"
        stroke-linejoin="round"
      />
      <path
        d="M5.849 10.6665L11 2H1L4.609 5.5415L5.849 10.6665Z"
        stroke="#3D352E"
        stroke-linejoin="round"
      />
    </svg>
  );
}
